import React, { useEffect, useState } from "react";
import { generalPostFunction } from "../Globals/globalFunctions";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import FormError from "../Components/FormError";
import { requiredValidator } from "../Components/FormValidations";
import { useDispatch, useSelector } from "react-redux";
import { allPlayersRefresh } from "../Redux/allPlayersSlice";
import { SvgIcon } from "../Components/SvgIcons";

function TransferPoints({ sendMessage }) {
	const [username, setUsername] = useState("");
	const [balance, setBalance] = useState("");
	const dispatch = useDispatch();
	const locationState = useLocation().state;
	const account = JSON.parse(localStorage.getItem("account"));

	const navigate = useNavigate();
	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
		watch,
		setValue,
	} = useForm();

	const setAllPlayers = useSelector((state) => state.allPlayers.setAllPlayers);

	useEffect(() => {
		if (locationState) {
			reset(locationState);
		}
	}, [locationState]);

	const transferPoints = async (data) => {
		const rawData = data;
		const payload = {
			username: account.username,
			password: account.password,
			target: rawData.username,
			amount: rawData.adjustType == "add" ? rawData.amount : -rawData.amount,
		};
		const response = await generalPostFunction("/maketransfer", payload, "3040");

		if (response.message.includes("transfer successful")) {
			sendMessage({
				action: "balance",
				data: [
					{
						username: rawData.username,
						amount: rawData.amount,
						type: rawData.adjustType,
					},
				],
			});
			toast.success("Funds transfered successfully!");
			dispatch(allPlayersRefresh((prev) => prev + 1));
			getUserData();
		} else {
			toast.error("Incorrect Username!");
		}
	};

	const getUserData = async () => {
		const payload = {
			username: account.username,
			password: account.password,
			platform: "dashboard",
		};
		try {
			const response = await generalPostFunction("/getuserdata", payload, "3040");
			if (response) {
				localStorage.setItem("account", JSON.stringify(response));
			}
		} catch (err) {
			console.log("Error fetching data: ", err);
		}
	};

	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>Transfer Points</h4>
									<p>Transfer point of an account</p>
								</div>
								<div className="buttonGroup">
									<button className="panelButton gray" onClick={() => navigate(-1)}>
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
									<button type="button" className="panelButton" onClick={handleSubmit(transferPoints)}>
										<span className="text">Save</span>
										<span className="icon">
											<SvgIcon name="save" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ padding: "25px 23px" }}>
							<form className="mb-0" onSubmit={handleSubmit(transferPoints)}>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Username</label>
									</div>
									<div className="col-6">
										<select className="formItem" {...register("username", requiredValidator)}>
											{setAllPlayers.map((item, index) => (
												<option value={item.username}>{item.username}</option>
											))}
										</select>
										{/* <input
                      className="formItem"
                      {...register("username", requiredValidator)}
                    /> */}
										{errors.username && <FormError message={errors.username.message} />}
									</div>
								</div>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Balance</label>
									</div>
									<div className="col-6">
										<input className="formItem" disabled value={parseInt(setAllPlayers?.find((item) => item?.username == watch()?.username)?.user_balance) || 0} />
									</div>
								</div>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Adjust Type</label>
									</div>
									<div className="col-6">
										<select className="formItem" defaultValue={"add"} {...register("adjustType", requiredValidator)}>
											<option value={"add"}>Add</option>
											<option value={"minus"}>Minus</option>
										</select>
										{errors.adjustType && <FormError message={errors.adjustType.message} />}
									</div>
								</div>
								<div className="formRow col-xl-6">
									<div className="formLabel">
										<label>Amount To Adjust</label>
									</div>
									<div className="col-6">
										<input className="formItem" {...register("amount", requiredValidator)} />
										{errors.amount && <FormError message={errors.amount.message} />}
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default TransferPoints;
